import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
import { API_PATH } from "../../utils/apis";

const initialState = {
  isLoading: false,
  error: false,
  search: "",
  page: 0,
  perPage: 10,
  total: 0,
  bookings: [],
  sortBy: null,
  filters: {
    method: "",
  },
};

const slice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    removeDeleteError(state) {
      state.isLoading = true;
      state.deleteError = false;
    },
    getSuccess(state, action) {
      state.isLoading = false;
      state.bookings = action.payload.data;
      state.total = parseInt(action.payload.total, 10);
    },
    deletedSuccess(state, action) {
      state.isLoading = false;
    },
    //  SORT & FILTER POSTS
    sortBy(state, action) {
      state.sortBy = action.payload;
    },
    filter(state, action) {
      state.filters.method = action.payload.method;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filter, sortBy } = slice.actions;

export function getBookings(
  search,
  stat,
  filters,
  page,
  perpage,
  order,
  sortBy,
) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(API_PATH.bookings, {
        page,
        perpage,
        order,
        sortBy,
        search,
        status: stat,
        ...filters,
        listing: filters?.listing?.uid || filters?.listing?.listingId || filters?.listing?.id || "",
      });
      const { status, data, total } = response.data;
      if (status === "success") {
        dispatch(slice.actions.getSuccess({ data, total }));
      } else {
        dispatch(
          slice.actions.hasError(
            new Error(
              "We cannot fetch your bookings at the moment! Please check back later.",
            ),
          ),
        );
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function cancelBooking(remove) {
  return async (dispatch) => {
    dispatch(slice.actions.removeDeleteError());
    try {
      const response = await axios.post(API_PATH.bookings, { remove });
      if (response.data.status === "success") {
        dispatch(slice.actions.deletedSuccess(remove));
      } else if (response.data.status === "permission_denied") {
        dispatch(
          slice.actions.hasDeleteError(
            new Error("You do not have permission to perform this action!"),
          ),
        );
      } else {
        dispatch(
          slice.actions.hasDeleteError(
            new Error("An error has occurred! Please try again later."),
          ),
        );
      }
    } catch (error) {
      dispatch(slice.actions.hasDeleteError(error));
    }
  };
}
